import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../img/logo/name-logo-light.svg';
// import { ReactComponent as Logo } from '../../img/logo/logo-white.svg';
import Drawer from '@material-ui/core/Drawer';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // zIndex: '2000',
    position: 'relative',

  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  list: {
    position: 'absolute',
    zIndex: '-2000',
    width: '30vw',
    top: '50px',
    right: '0',
    paddingLeft: '2rem',
    height: '400px',
    // backgroundColor: 'red',
    transition: 'all 0.6s linear',
    backgroundColor: 'rgba(41,42,48,.9)',
    [theme.breakpoints.down('sm')]: {
      top: '50px',
      right: '0',
      width: '200px' ,
      height: '260px',
    },
    [theme.breakpoints.up('sm')]: {
      top: '50px',
      right: '0',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('md')]: {
      top: '50px',
      right: '0',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('lg')]: {
      top: '50px',
      right: '0',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('xl')]: {
      top: '50px',
      right: '0',
      width: '350px' ,
      height: '350px',
    },
  },
  listClosed: {
    position: 'absolute',
    zIndex: '-1',
    width: '30vw',
    top: '-400px',
    right: '0',
    paddingLeft: '2rem',
    height: '400px',
    // backgroundColor: 'red',
    transition: 'all 0.6s linear',
    backgroundColor: 'rgba(41,42,48,.9)',
    [theme.breakpoints.down('sm')]: {
      top: '50px',
      right: '-200px',
      width: '200px',
      height: '260px',
    },
    [theme.breakpoints.up('sm')]: {
      top: '50px',
      right: '-350px',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('md')]: {
      top: '50px',
      right: '-350px',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('lg')]: {
      top: '50px',
      right: '-350px',
      width: '350px' ,
      height: '350px',
    },
    [theme.breakpoints.up('xl')]: {
      top: '50px',
      right: '-350px',
      width: '350px' ,
      height: '350px',
    },
  },
  link: {
    // margin: '1.5rem 0', 
    padding: '1.5rem 0', 
    width: '90%',
    // height: '50px',
    fontSize: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1.1rem 0', 
      fontSize: '1rem',
    },
    [theme.breakpoints.up('sm')]: {

    },
    [theme.breakpoints.up('md')]: {

    },
    [theme.breakpoints.up('lg')]: {

    },
    [theme.breakpoints.up('xl')]: {

    },

  },
  drawerPaper: {
    backgroundColor: 'transparent',
    top: '50px',
    // cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      // right: '7px',
      height: '60vh',
    },
    [theme.breakpoints.up('sm')]: {
      // right: '15px',
      height: '30vh',
    },
    [theme.breakpoints.up('md')]: {
      // right: '30px',
      height: '60vh',
    },
    [theme.breakpoints.up('lg')]: {
      // right: '30px',
      height: '60vh',
    },
    [theme.breakpoints.up('xl')]: {
      // right: '30px',
      height: '380px',
    },

  }
}));

const Navbar = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    open ? setOpen(false) : setOpen(true)
  }

  React.useEffect(() => {
   
    const menu = document.getElementById('menu-dropdown-root');
    const menuBurger = document.getElementById('menu-burger-click');
    const menuLine1 = document.getElementById('menu-line-1');
    const menuLine2 = document.getElementById('menu-line-2');
    const Link1 = document.getElementById('menu-link-1');
    const Link2 = document.getElementById('menu-link-2');
    const Link3 = document.getElementById('menu-link-3');
    const Link4 = document.getElementById('menu-link-4');
    document.onclick = function(e) {
      if(open 
        && e.target !== menuBurger
        && e.target !== menuLine1
        && e.target !== menuLine2
        && e.target !== menu
        && e.target !== Link1
        && e.target !== Link2
        && e.target !== Link3
        && e.target !== Link4
        ) {
        handleDrawerClose()
      }
      // if(open && e.target !== menuBurger) {
      //   handleDrawerClose()
      //   console.log(open, "test")
      // }
    }
  })


  const list = () => (
    <div
      className={open ? classes.list : classes.listClosed}
      role="presentation"
      onClick={handleDrawerClose}
      onKeyDown={handleDrawerClose}
      id="menu-dropdown-root"
    >

      <div style={{ color: '#fff', fontWeight: '500', width: '100%', display: 'flex', flexDirection: 'column', }}>
        <Link id='menu-link-1' to="/" className={classes.link}>Start</Link>
        <Link id='menu-link-2' to="/about" className={classes.link}>Om mig</Link>
        <Link id='menu-link-3' to="/kodprojekt" className={classes.link}>Portfolio kod</Link>
        <Link id='menu-link-4' to="/designprojekt" className={classes.link}>Portfolio design</Link>
        
      </div>
    </div>
  );
  return (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: 'rgba(41,42,48,0.9)' }}>
        {list()}
        <Toolbar style={{ minHeight: '50px', }} className="px-2 px-lg-5">
          {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton> */}
          <div style={{ display: 'flex', alignItems: 'center', width: '210px' }}>
            <Link to="/"><Logo style={{ height: '20px',  }}/></Link>
            {/* <Link to="/" style={{ letterSpacing: '5px', color: '#fff' }}>Sanne Sidell.</Link>  */}
          </div>
          <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/about" style={{ marginRight: '16px' }}>About</Link>
          <Link to="/kodprojekt" style={{ marginRight: '16px' }}>Kod Projekt</Link>
          <Link to="/designprojekt">Design Projekt</Link>
          </div> */}
            {/* {
              open ? 
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <div className='close-menu' onClick={handleDrawerClose}>
                  <div className='close-menu-line1'></div>
                  <div className='close-menu-line2'></div>
                </div>
              </div>
              : 
              <div className={open ? 'menu' : 'menu'} onClick={handleDrawerOpen}>
                <div className={open ? 'exit-menu-line1' : 'menu-line1'}></div>
                <div className={open ? 'exit-menu-line2' : 'menu-line2'}></div>
              </div>
            } */}
              <div id="menu-burger-click" className={open ? 'menu' : 'menu'} onClick={handleToggle}>
                <div id="menu-line-1" className={open ? 'close-menu-line1' : 'menu-line1'}></div>
                <div id="menu-line-2" className={open ? 'close-menu-line2' : 'menu-line2'}></div>
              </div>
              
          {/* <React.Fragment >

              <div className={open ? 'menu' : 'menu'} onClick={handleDrawerOpen}>
                <div className={open ? 'close-menu-line1' : 'menu-line1'}></div>
                <div className={open ? 'close-menu-line2' : 'menu-line2'}></div>
              </div>
            <Drawer 
              classes={{
                paper: classes.drawerPaper,
              }} 
              // anchor="top" 
              anchor="right" 
              open={open} 
              onClose={handleDrawerClose}
              BackdropProps={{ invisible: true }}
            >
              {list()}
            </Drawer>
          </React.Fragment> */}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Navbar